export default {
  en: {
    snack: {
      card_delete_success: 'Card deleted successfully',
      generic_error: 'Something went wrong',
      subscribe: {
        on: 'Successfully subscribed',
        off: 'Successfully unsubscribed',
      },
      bookmark: {
        on: 'Successfully bookmarked',
        off: 'Successfully removed bookmark',
      },
      pin: {
        on: 'Successfully pinned',
        off: 'Successfully unpinned',
      },
    },
    confirm_dialog_msg: {
      default: 'Are you sure?',
    },
    actions: {
      subscribe: {
        on: 'Unsubscribe',
        off: 'Subscribe',
      },
      bookmark: {
        on: 'Remove bookmark',
        off: 'Bookmark',
      },
      pin: {
        on: 'Unpin',
        off: 'Pin',
      },
      likes: 'Likes',
      contact: 'Contact',
      inappropriate_report: 'Report as inappropriate',
      settings: 'Edit',
      duplicate: 'Duplicate',
      send_via_email: 'Send via email',
      add_unavailable_term: 'Add unavailable term',
      delete: 'Delete',
      admin: 'Admin',
      cancel: 'Cancel',
      reveal: 'Reveal',
      hide: 'Hide',
      move: 'Move card',
    },
  },
};
